import { NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import { CommonModule} from '@angular/common';
import { RouterModule } from '@angular/router';
import { QuestionnaireViewComponent } from './questionnaire-view.component';
import { CreateQuestionComponent } from '../createQuestion/create-question.component';
import { CreateChoiceComponent } from '../createChoice/create-choice.component';
import { AddFileToDownloadModule } from '../../addFileDownload/add-file-to-download.module';
import { TranslatePipeModule } from '../../translate/translate.pipe.module';
import {GenericModalModule} from '../../modal/generic-modal.module';
import {MaterialChipsInputModule} from '../tags/materialChipsInput.module';
import {ImportDuplicateModalModule} from '../../import-duplicate-modal/import-duplicate-modal.module';
import {FileChooserModule} from '../../FileChooser/file-chooser.module';
import {BreadCrumbModule} from '../../bread-crumb/bread-crumb.module';
import {CreateQuestionnaireModule} from '../createQuestionnaire/create-questionnaire.module';
import {SharedRefreshService} from '../../service/sharedRefreshService';
import {DatePickerModule} from '@syncfusion/ej2-angular-calendars';

@NgModule({
    imports: [CommonModule, RouterModule, AddFileToDownloadModule, TranslatePipeModule, FormsModule, GenericModalModule, MaterialChipsInputModule, ImportDuplicateModalModule, FileChooserModule, BreadCrumbModule, CreateQuestionnaireModule, DatePickerModule, ReactiveFormsModule],
  declarations: [ QuestionnaireViewComponent,CreateQuestionComponent,CreateChoiceComponent],
  providers: [SharedRefreshService],
  exports:[ QuestionnaireViewComponent]
})
export class QuestionnaireViewModule {

}
